import { ItemScreeningReport } from './ItemScreeningReport'

export const ContentOrderScreening = () => {
  return <ItemScreeningReport />
}
